import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { AlertCircle, XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useLocation } from "wouter";

interface PublicOrderErrorProps {
  error: Error | string | null;
  noId?: boolean;
}

export function PublicOrderError({
  error,
  noId = false,
}: PublicOrderErrorProps) {
  const [, setLocation] = useLocation();

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4">
      <div className="max-w-md w-full">
        <Alert variant={noId ? "default" : "destructive"}>
          {noId ? (
            <AlertCircle className="h-4 w-4" />
          ) : (
            <XCircle className="h-4 w-4" />
          )}
          <AlertTitle>{noId ? "Invalid Order" : "Order Not Found"}</AlertTitle>
          <AlertDescription className="mt-2">
            {noId ? (
              "No order ID provided. Please check your order link and try again."
            ) : (
              <>
                <p className="mb-4">
                  {error instanceof Error
                    ? error.message
                    : typeof error === "string"
                    ? error
                    : "The requested order could not be loaded. Please check your order number and try again."}
                </p>
                <Button
                  variant="outline"
                  onClick={() => setLocation("/")}
                  className="w-full"
                >
                  Go to Homepage
                </Button>
              </>
            )}
          </AlertDescription>
        </Alert>
      </div>
    </div>
  );
}
